// Firebase client initialization for frontend verification flows
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

let app = null;
try {
  // Only initialize if config looks provided
  if (firebaseConfig.apiKey && firebaseConfig.authDomain) {
    app = initializeApp(firebaseConfig);
  }
} catch (e) {
  // Ignore initialization errors; callers should handle missing auth
  // eslint-disable-next-line no-console
  console.warn('Firebase initialization failed or already initialized', e?.message || e);
}

export const auth = app ? getAuth(app) : null;

export default app;
